import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';
import pairablePrinters from 'garaje/utils/pairable-printers';

const PRINTER_MODELS = pairablePrinters.map((p) => p.printerModel);
const BLUETOOTH_PRINTER_MODELS = pairablePrinters.filter((p) => p.bluetoothEnabled).map((p) => p.printerModel);

export default Factory.extend({
  devices: () => [],
  ip: null,
  enabled: false,
  model: faker.helpers.arrayElement(PRINTER_MODELS),
  name(i) {
    return `Printer ${i}`;
  },
  status: 'connected',

  asBluetoothPrinter: trait({
    connectionType: 'bluetooth',
    model: faker.helpers.arrayElement(BLUETOOTH_PRINTER_MODELS),
  }),

  asIntegrationPrinter: trait({
    connectionType: 'integration',
    model: 'Integration',
  }),

  /*
    When adding a printer, the UI asks for the type of connection. While "Ethernet" and "Wifi" are separate
    options, they both use the same connectionType value and are indistinguishable once created.
  */
  asEthernetPrinter: trait({
    connectionType: 'ip',
    ip: faker.internet.ip(),
  }),

  asWifiPrinter: trait({
    connectionType: 'ip',
    ip: faker.internet.ip(),
  }),

  asPrintNodePrinter: trait({
    connectionType: 'printnode',

    externalResourceUid(i) {
      return `${i * 13 + 5000}`;
    },

    afterCreate(printer, server) {
      if (!printer.printerConnectionId) {
        const { location, property } = printer;
        const printerConnection = server.create('printer-connection', { location, zone: property });

        printer.update({ printerConnectionId: printerConnection.id });
      }
    },
  }),

  asOperational: trait({
    afterCreate(printer, server) {
      server.create('device', {
        printer,
        zone: printer.property,
        printerStatus: 'connected',
        lastHeartbeatAt: new Date(),
      });
    },
  }),

  checkIpads: trait({
    afterCreate(printer, server) {
      server.create('device', {
        printer,
        zone: printer.property,
        printerStatus: 'connected',
        lastHeartbeatAt: new Date(),
      });

      server.create('device', {
        printer,
        zone: printer.property,
        printerStatus: '',
        lastHeartbeatAt: new Date(),
      });
    },
  }),
});
